import { module } from "modujs";
import { IS_ANDROID, IS_IOS } from "../utils/ar-detection";

// Install modules

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.$model = this.$('model')[0];
        this.$buttonOpen = this.$('buttonOpen')[0];
        this.$buttonClose = this.$('buttonClose')[0];

        this.isAndroid = IS_ANDROID
        this.isIOS = IS_IOS
        this.loaded = false

        this.bindEvents()
    }

    bindEvents() {
        this.modelLoaded = this.modelLoaded.bind(this)
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)

        this.$model.addEventListener('load', this.modelLoaded)
        this.$buttonOpen.addEventListener('click', this.showModal)
        this.$buttonClose.addEventListener('click', this.hideModal)
    }

    unbindEvents() {
        this.$model.removeEventListener('load', this.modelLoaded)
        this.$buttonOpen.addEventListener('click', this.showModal)
        this.$buttonClose.addEventListener('click', this.hideModal)
    }

    showModal() {
        //if (!this.isIOS) {}
            
        this.el.classList.add('is-open')
        this.show3dContent()
    }

    hideModal() {
        this.el.classList.remove('is-open')
    }

    show3dContent() {

        if (!this.loaded) {
            this.$model.dismissPoster()
        }

        // if (!this.isAndroid && !this.isIOS) {
        //     this.$model.dismissPoster()
        // } else this.$model.activateAR()
    }

    modelLoaded() {
        this.loaded = true
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
